import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Button,
    Collapse,
    Row,
} from 'reactstrap';

import ApplicantCard from './ApplicantCard';
import UserBubble from '../../../components/user/UserBubble';
import {fetchGroupPDF} from "../actions/applicants";
import PolyUtil from "../../../util/PolyUtil";
import Loader from "../../../components/display/Loader";
import {AsyncButton} from "../../../components/controls/buttons/AsyncButton";
import CircleButton from "../../../components/controls/buttons/CircleButton";
import ScoreIndicator from "../../../components/display/ScoreIndicator";
import OwnerApplicationDecisionForm from "./OwnerApplicationDecisionForm";
import {displayModal} from "../../../store/actions/display";
import ReduxModalWrapper from "../../../components/display/Modals/ReduxModalWrapper";

class OwnerApplicationGroupRow extends Component {
    state = {
        showGroup: false,
        showConfirmModal: false,
        confirmMode: ''
    };

    toggleCollapse = () => {
        this.setState({showGroup: !this.state.showGroup});
    };

    toggleConfirmModal = (mode) => {
        this.setState({showConfirmModal: !this.state.showConfirmModal});
        this.setState({confirmMode: mode});
    };

    showConfirmModal = (mode) => {
        this.props._displayModal({
            id: "confirm_roommate_group_modal_" + this.props.roommateGroup.id,
            header: "Confirm " + ((mode === 'qualify') ? 'Qualification' : 'Deferral'),
            body: (<OwnerApplicationDecisionForm ids={this.props.ids} roommateGroup={this.props.roommateGroup} confirmMode={mode}/>)
        });
    };

    content = () => {
        const {_fetchGroupPDF, roommateGroup, ids} = this.props;
        const toggle = this.toggleCollapse;

        return (
            <Row>
                <div className="owner-property-applications-group">
                    <div className="owner-property-applications-row wrappable justify-content-center">
                        <div className="owner-property-applications-control-group mobile-max-width">
                            <ScoreIndicator value={roommateGroup.average_score} size={75}/>
                        </div>
                        <div className="owner-property-applications-control-group">
                            {
                                roommateGroup.roommates.map(function (member, i) {
                                    return <UserBubble key={i}
                                                       small
                                                       dark
                                                       onClick={toggle}
                                                       margin="0 0.25rem"
                                                       initials={member.get_first_name.charAt(0) + "" + member.get_last_name.charAt(0)}/>;
                                })
                            }
                            <CircleButton color="info" outline onClick={this.toggleCollapse}>{this.state.showGroup ? (<i className="fa fa-chevron-up"></i>)
                                : (<i className="fa fa-chevron-down"></i>)}</CircleButton>
                        </div>

                        <div className="owner-property-applications-control-group ml-auto mobile-max-width">
                            <AsyncButton color="info" style={{margin: "0 0.5rem"}} outline noComplete task={_fetchGroupPDF}>Download Applications</AsyncButton>
                            {
                                !roommateGroup.accepted &&
                                    <div>
                                        <Button color="success" onClick={() => this.showConfirmModal('qualify')} style={{width: '5rem', margin: "0.5rem 0.5rem"}} outline>Qualify</Button>
                                        <Button color="danger" onClick={() => this.showConfirmModal('defer')} style={{width: '5rem', margin: "0.5rem 0.5rem"}} outline>Defer</Button>
                                    </div>
                            }
                        </div>
                    </div>
                    {
                        this.state.showGroup && (<hr width="100%"/>)
                    }
                    <div className="owner-property-applications-row scrollable">
                        <Collapse isOpen={this.state.showGroup} className="mt-2">
                            <div className="owner-property-applications-card-deck">
                                {
                                    roommateGroup.roommates.map(function (member, i) {
                                        return (
                                            <div key={i} className="owner-property-applications-card-container">
                                                <ApplicantCard propId={ids.prop_id} roommate={member}/>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </Collapse>
                    </div>
                </div>

                <ReduxModalWrapper id={"confirm_roommate_group_modal_" + roommateGroup.id}/>
            </Row>
        );
    };

    render() {
        return PolyUtil.propsReady(this.props, ['roommateGroup, ids']) ? this.content() : <Loader spin isLoading/>;
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch, props) => ({
    _fetchGroupPDF() {
        const fileName = PolyUtil.createPDFName(props.roommateGroup.roommates.map(function (roommate) {
            return roommate.get_last_name;
        }));
        return dispatch(fetchGroupPDF(props.ids.prop_id, props.ids.listing_id, props.roommateGroup.id, fileName));
    },
    _displayModal(modalData) {
        return dispatch(displayModal(modalData));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(OwnerApplicationGroupRow);



// WEBPACK FOOTER //
// ./src/containers/owner/applications/OwnerApplicationGroupRow.js